import {Config} from "./config-viewmodel";
import { IStudies } from "@/shared/models/api/study-choice-studies-model";

export interface MyFavoriteStudiesState {
    loading: boolean,
    inner_loading: boolean,
    study_search_modal: boolean
    config: Config,
    studies: IStudies
    search_query: string
}

export class WidgetState implements MyFavoriteStudiesState {
    loading: boolean = false
    inner_loading: boolean = false
    study_search_modal: boolean = false
    config: Config = {
        labels: {
            favoriteStudiesTitle: '',
            emptyFavoriteStudies: '',
            viewProgramInformation: '',
            searchPlaceholder: '',
            addAProgram: '',
            add: '',
            added: '',
            filteredNumberOfPrograms: '',
            noResultsFound: '',
            loadingStudies: ''
        },
        language: '',
        apibaseurl: ''
    }
    studies: IStudies = []
    search_query: string = ''
}
